import { StartupService } from 'app/shared/services/startup.service';
import { AppSettings } from 'app/shared/app-settings';
import { BaseFormValidation } from './../../../shared/validators/base-form-validation';
import { CustomValidators } from './../../../shared/validators/custom-validators';
import { SecurityService } from './../../security.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'online-app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends BaseFormValidation  implements OnInit {

  protected isRequestResetStep:boolean;
  protected requestResetForm:FormGroup;
  protected resetPasswordForm:FormGroup;

  constructor(private activeRoute:ActivatedRoute, 
    private router:Router,private fb:FormBuilder, private securityService:SecurityService,
          private startupSer:StartupService) {
    super();
      this.requestResetForm=fb.group({
        'email':[null,[Validators.required, CustomValidators.isEmail()]],
        'programAlias':null
      });

      this.resetPasswordForm=fb.group({
        'newPassword':[null,[Validators.required,CustomValidators.PasswordStrength(this.startupSer.passwordConfig)]],
        'confirmPassword':[null,Validators.required],
        'activationCode':null
      },{
        validator:CustomValidators.MatchPassword
      })
    

    this.activeRoute.params.subscribe(params => {
      this.isRequestResetStep=!params["token"];
      this.resetPasswordForm.get('activationCode').setValue(params["token"]);      
      this.requestResetForm.get('programAlias').setValue(params['type']);
     });

   }

  ngOnInit() {

  }

  protected requestReset(){
    if(this.requestResetForm.valid)
    this.securityService.requestForgotPassword(this.requestResetForm.value).subscribe(()=>{
      this.securityService.toastr.success('Please, check your email for further instructions','Success')
    })
  }

  protected doReset(){
    if(this.resetPasswordForm.valid)
    this.securityService.forgotPasswordDoReset(this.resetPasswordForm.value).subscribe(()=>{
      this.securityService.toastr.success('Your password successfully reseted','Success');
      this.router.navigate(['/security/login']);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/security/security/forgot-password/forgot-password.component.ts